import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Button, Grid } from "@mui/material";
import { EditNote } from "@mui/icons-material";
import { RouteCollectionInfo } from "../../redux/route/state";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { axiosGet } from "../../util/axios";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import {
    initCollectionAttendanceData,
    initUnloadDataThunk,
} from "../../redux/collection/thunk";
import FormDialog from "../common/FormDialog";
import CollectionAttendace from "./CollectionAttendace";
import Unload from "./Unload";

function CollectionRoute() {
    const [detailDialog, setDetailDialog] = useState<boolean>(false);
    const [unloadDialog, setUnloadDialog] = useState<boolean>(false);
    const dispatch = useDispatch<IRootThunkDispatch>();
    const { RouteCollectionList } = useSelector(
        (state: IRootState) => state.routeState
    );

    async function handleClickAttendanceDetailButton(
        routeCollectionInfo: RouteCollectionInfo
    ) {
        dispatch(OpenLoadingBarThunk(true));
        const result = await axiosGet(
            `/api/collection/attendance/${routeCollectionInfo.route_id}`
        );
        dispatch(OpenLoadingBarThunk(false));
        if (result.data.success) {
            dispatch(initCollectionAttendanceData(result.data.routeList));

            setDetailDialog(true);
        } else {
            dispatch(OpenSnackBarWithResultFail("未能取得詳情資料"));
        }
    }

    function handleCloseDialog() {
        setDetailDialog(false);
        setUnloadDialog(false)
    }

    async function handleClickUnloadDetailButton(
        routeCollectionInfo: RouteCollectionInfo
    ) {
        dispatch(OpenLoadingBarThunk(true));

        const result = await axiosGet(
            `/api/unload/${routeCollectionInfo.route_id}`
        );

        if (result.data.success) {
            dispatch(initUnloadDataThunk(result.data.unloadData));

            setUnloadDialog(true);
        }

        dispatch(OpenLoadingBarThunk(false));
    }

    const columns: GridColDef[] = [
        {
            field: "route_id",
            headerName: "車線號碼",
            flex: 1,
        },
        { field: "route_name", headerName: "車線名稱", flex: 1 },
        { field: "username", headerName: "收集司機", flex: 1 },
        {
            field: "action",
            headerName: "路線打卡詳情",
            flex: 1,
            renderCell: (data) => {
                return (
                    <Button
                        variant="contained"
                        onClick={() => handleClickAttendanceDetailButton(data.row)}
                    >
                        <EditNote />
                        <Grid>車線詳情</Grid>
                    </Button>
                );
            },
        },
        {
            field: "action2",
            headerName: "卸貨詳情",
            flex: 1,
            renderCell: (data) => {
                return (
                    <Button
                        variant="contained"
                        onClick={() =>
                            handleClickUnloadDetailButton(data.row)
                        }
                    >
                        <EditNote />
                        <Grid>卸貨詳情</Grid>
                    </Button>
                );
            },
        },
    ];

    return (
        <div>
            <Grid>本日車線共 {RouteCollectionList.length} 條</Grid>

            <div style={{ height: "100%", width: "100%" }}>
                <DataGrid
                    rows={RouteCollectionList || []}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 30 },
                        },
                    }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    getRowId={(row) => row.route_id}
                />
            </div>

            <FormDialog
                title="詳細打卡情況"
                open={detailDialog}
                handleClose={handleCloseDialog}
                size="xl"
            >
                <CollectionAttendace />
            </FormDialog>


            <FormDialog
                title="詳細卸貨情況"
                open={unloadDialog}
                handleClose={handleCloseDialog}
                size="xl"
            >
                <Unload />
            </FormDialog>
        </div>
    );
}

export default CollectionRoute;
